export default "__VITE_ASSET__b$M2$0We__"